import React from 'react';

import { MobileFilter2 } from '../../../filter/MobileFilter2';
import { CellHeightFilter } from '../../../../models/Filter';
import { CeilHeightNewFilterView } from '../../ceil_height/CeilHeightNewFilterView';

interface IMobileCeilHeightFilter {
    filter: CellHeightFilter;
    handleChange: (filter: CellHeightFilter) => void;
    classNameGroup?: string;
}

export const MobileCeilHeightFilterButtonView: React.FC<IMobileCeilHeightFilter> = ({
    filter,
    handleChange,
    classNameGroup
}) => {
    return (
        <MobileFilter2 filterTitle='Высота потолков'>
            <CeilHeightNewFilterView
                filter={filter}
                handleChange={handleChange}
                classNameGroup={classNameGroup}
            />
        </MobileFilter2>
    );
};
